export const getCommandBarItems = (
  translator,
  selectedHearingTypeIsActive,
  onChangeHearingTypeIsActive,
  isUpdatingHearingType,
  selectedHearingTypeNumberOfHearings,
  selectedHearingTypeId,
  onDeleteHearingType,
  openPanel,
  isFetchingData,
) => {
  return [
    {
      key: 'addHearingType',
      name: translator('pages.adminHearingTypes.addHearingType'),
      iconProps: {
        iconName: 'Add',
      },
      onClick: openPanel,
      disabled: isFetchingData,
      buttonStyles,
    },
    {
      key: 'activateHearingType',
      name: translator('pages.adminHearingTypes.activateHearingType'),
      iconProps: {
        iconName: 'ActivateOrders',
      },
      onClick: () => onChangeHearingTypeIsActive(true),
      disabled:
        isUpdatingHearingType ||
        selectedHearingTypeIsActive === null ||
        selectedHearingTypeIsActive,
      buttonStyles,
    },
    {
      key: 'deactivateHearingType',
      name: translator('pages.adminHearingTypes.inactivateHearingType'),
      iconProps: {
        iconName: 'DeactivateOrders',
      },
      onClick: () => onChangeHearingTypeIsActive(false),
      disabled: isUpdatingHearingType || !selectedHearingTypeIsActive,
      buttonStyles,
    },
    {
      key: 'deleteHearingType',
      name: translator('pages.adminHearingTypes.deleteHearingType'),
      iconProps: {
        iconName: 'Delete',
      },
      onClick: onDeleteHearingType,
      disabled:
        isUpdatingHearingType ||
        selectedHearingTypeId === null ||
        selectedHearingTypeNumberOfHearings !== 0,
      buttonStyles,
    },
  ];
};

const buttonStyles = {
  root: {
    backgroundColor: '#FAFAFA',
  },
  rootDisabled: {
    backgroundColor: '#FAFAFA',
  },
};
